<template>
	<v-container fill-height fluid class="form-container" id="user-confirmation-page">
		<div class="nav-container">
			<div id="parallelogram">
				<img src="/static/images/navbar/logo-color.svg" class="unskew" height="35" alt="WRKPRTY" />
			</div>
		</div>
		<div style="position: absolute; top: 0%; right: 10%; width: 50%;" class="hidden-md-and-up">
			<div v-if="!editPhoto" class="profile-header__user-image mt-5 mb-5" style="position: relative;">
				<img :src="user.avatar" alt="" style="z-index: -1;">
				<div @click="editPhoto=true">
					Edit
				</div>
			</div>
			<div class="profile-header" v-else>
				<profile-picture-upload v-on:noEditPhoto="editPhoto=false"></profile-picture-upload>
				<!-- <v-btn @click="editPhoto=false">Cancel</v-btn> -->
			</div>
		</div>
		<v-layout row wrap align-center>
			<a @click="logout" class="hidden-xs-only link-blue pl-5 pb-5" style="position: absolute; bottom: 0; left: 0;">
				Cancel and Logout
			</a>
			<v-flex xs12 md3 offset-md1 class="border-right-md first-column" style="height: 70%;">
				<v-layout justify-center align-center style="position: relative;">
					<v-flex xs12>
						<h1 class="display-1 mb-2">Hi {{ user.first_name || 'there!' }}!</h1>
						<p class="mt-3 mb-3" style="color: #888">Just one last step...</p>
						<p class="mt-3 mb-3" style="color: #888;">Please verify your email is correct.</p>
						<p class="mt-2 mb-5" style="color: #888; font-size: 0.85em;">*It's where we'll send your RSVP confirmations.</p>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 md7>
				<v-form ref="form">
					<v-layout row wrap justify-center align-center>
						<v-flex xs12 md7 offset-md1>
							<div v-if="!editPhoto" class="profile-header__user-image mt-5 mb-5 hidden-sm-and-down" style="position: relative; overflow: hidden">
								<img :src="user.avatar" alt="">
								<div @click="editPhoto=true">
									Edit
								</div>
							</div>
							<div class="profile-header hidden-sm-and-down" v-else>
								<profile-picture-upload v-on:noEditPhoto="editPhoto=false"></profile-picture-upload>
								<!-- <v-btn @click="editPhoto=false">Cancel</v-btn> -->
							</div>
							<p style="color: #777;" class="mb-0">My best email address is...</p>
							<input id="number" class="hosted-field" v-model="computedEmail" :style="getInputStyle" />
							<p style="font-size: 0.9em;" class="mb-0 error--text"><span v-if="!validEmail">Please enter a valid email address</span><span v-else>&nbsp;</span></p>
							
							<!-- <p style="color: #777;" class="mb-0">Where did you hear about us?</p>
							<v-select
								id="where-from-input"
								class="pt-0"
								:items="choices"
								v-model="whereFrom"
								hide-details
								single-line
								required
							></v-select> -->


							<div style="width: 100%" class="text-xs-center">
								<v-btn large class="btn-blue mt-3 hidden-xs-only elevation-0" @click="saveInfo" style="width: 80%; height: 60px; border-radius: 10px;"><b>Yes, this is correct</b></v-btn>
								<p v-if="error" class="error--text">{{ error }}</p>
							</div>
							<p class="mt-5 mb-5" style="color: #777; font-size: 0.75em;">NOTE: By accessing the wrkprty platform you are acknowledging you have read and agree to our <a class="link-blue" @click="setModalOpen({prop: 'termsModal', value: true})">terms of use</a> and <a class="link-blue" @click="setModalOpen({prop: 'termsModal', value: true})">privacy policy</a>.</p>
							<!-- <h4 class="mt-2">My birthday is</h4> -->
						</v-flex>
						<!-- <v-flex xs12 md8 offset-md1>
							<v-layout row wrap>
								<v-flex xs5 class="pr-2">
									<v-select hide-details single-line v-model="month" :items="months" label="Month" item-text="name" item-value="value"></v-select>
								</v-flex>
								<v-flex xs3 class="pr-2">
									<v-select hide-details single-line v-model="day" :items="days" label="Day"></v-select>
								</v-flex>
								<v-flex xs4>
									<v-select hide-details single-line v-model="year" :items="years" label="Year"></v-select>
								</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs12 md8 offset-md1>
							<h4 class="mt-2">I am a</h4>
							<div>
								<v-select
									hide-details
									v-bind:items="genderOptions"
									v-model="gender"
									label=""
									single-line
									bottom
									class="pa-0"
								></v-select>
							</div>
							<v-layout row class="mt-1" style="min-width: 150px; width: 75%">
								<v-flex xs2 sm1>
									<v-checkbox color="link" hide-details v-model="acceptedTerms"></v-checkbox>
								</v-flex>
								<v-flex xs10 sm11>
									<p class="mt-1">I agree to the <a class="link-blue" @click="setModalOpen({prop: 'termsModal', value: true})">Terms &amp; Conditions</a></p>
								</v-flex>
							</v-layout>
							 
						</v-flex> -->
					</v-layout>
				</v-form>
			</v-flex>
		</v-layout>
		<div class="hidden-sm-and-up mobile-submit-btn">
			<v-btn class="btn-blue" @click="saveInfo" style="height: 70px;">Yes, this is correct</v-btn>
		</div>
	</v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'

import ProfilePictureUpload from '~/components/ProfilePictureUpload.vue'

import { rawAxiosGet } from '~/plugins/rawAxios'
import { isEmpty } from '~/store/util/util'
import * as TYPE from '~/store/util/types'

export default {
	name: 'user-confirmation',
	$validates: true,
	data() {
		return {
			error: null,
			provider: null,
			editPhoto: false,
			pk: '',
			genderOptions: ['Male', 'Female', 'Other'],
			day: null,
			month: null,
			year: null,
			gender: null,
			acceptedTerms: false,
			email: '',
			validEmail: false,
			whereFrom: null,
			choices: [
				{ text: 'Other', value: 'other' },
				{ text: 'Meetup', value: 'meetup' },
				{ text: 'Eventbrite', value: 'eventbrite' },
				{ text: 'Built In LA', value: 'builtinla' },
				{ text: 'From a friend', value: 'friend' },
				{ text: 'Facebook', value: 'facebook' },
				{ text: 'Instagram', value: 'instagram' },
				{ text: 'Google', value: 'google' },
				{ text: 'Twitter', value: 'twitter' }
			],
			nameRules: [
				v => !!v || 'Name is required',
				v => v.length <= 20 || 'Name must be less than 20 characters'
			],
			emailRules: [
				v => !!v || 'E-mail is required',
				v => {
					let result = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(
						v
					)
					this.validEmail = result
					return result
				}
			]
		}
	},
	mounted() {
		this.email = this.user.email
		let result = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(
			this.email
		)
		this.validEmail = result
	},
	methods: {
		...mapActions([
			'serverPutUserProp',
			'setModalOpen',
			'setAuthRedirect',
			'setUserProp',
			'setUserSocial',
			'logout'
		]),
		saveInfo() {
			const userProps = {
				id: this.user.pk,
				email: this.email
			}
			this.setUserProp(userProps).then(response => {
				axios
					.post('/api/v1/user/confirmation/', userProps)
					.then(response => {
						this.setUserProp({ active: true })
						this.setUserSocial(this.user)
						if (this.getAuthRedirect) {
							let r = this.getAuthRedirect
							this.setAuthRedirect(null)
							this.$router.replace(r)
						} else {
							this.$router.replace('/')
						}
					})
					.catch(error => {
						console.error(error)
						this.error = error.response.data
					})
			})
		}
	},
	computed: {
		...mapGetters(['getAuthRedirect', 'user']),
		computedEmail: {
			get() {
				return this.email
			},
			set(val) {
				let result = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(
					val
				)
				this.validEmail = result
				this.email = val
			}
		},
		getFormInvalid() {
			return !this.validEmail || this.whereFrom === null
		},
		days() {
			return Array(31)
				.fill()
				.map((e, i) => i + 1)
		},
		years() {
			return Array(100)
				.fill()
				.map((e, i) => i + 1918 - 18)
				.reverse()
		},
		getInputStyle() {
			if (!this.validEmail) {
				return {
					'border-bottom': '2px solid #de6455',
					transition: 'all 200ms ease'
				}
			}
		}
	},
	components: {
		ProfilePictureUpload
	}
}
</script>

<style lang="scss" scoped>

.nav-container {
	overflow: hidden;
}
.unskew {
	margin: 14px 40px;
	-webkit-transform: skew(20deg);
	-moz-transform: skew(20deg);
	-o-transform: skew(20deg);
}
#parallelogram {
	min-width: 150px;
	width: 15%;
	height: 64px;
	margin: 0 0 0 -20px;
	-webkit-transform: skew(-20deg);
	-moz-transform: skew(-20deg);
	-o-transform: skew(-20deg);
	background: #f3f3f3;
	overflow: hidden;
	position: absolute;
	top: 0;
	left: 0;
}

.hosted-field {
	height: 45px;
	display: block;
	background-color: transparent;
	color: #666;
	border: none;
	border-bottom: 1px solid rgba(0, 0, 0, 0.54);
	outline: 0;
	width: 100%;
	font-size: 25px;
	padding: 0;
	box-shadow: none;
	border-radius: 0;
	position: relative;
	&:focus {
		border-bottom: 2px solid #74cbf1;
		transition: all 200ms ease;
	}
}

@media screen and (max-width: 1264px) {
	.first-column {
		margin-bottom: 15px;
		height: auto !important;
		> div {
			height: auto !important;
		}
	}
	.form-container {
		height: auto !important;
		padding: 90px 10px 50px 10px !important;
	}
	.profile-header {
		text-align: center;
		width: 100%;
		padding: 2px;
		text-align: center;

		&__user-image {
			margin: 0 auto;
			overflow: hidden;
			object-fit: cover;
			border: 5px solid #fafafa;
			border-radius: 50%;
			max-width: 150px;
			max-height: 150px;

			> img {
				width: 100%;
			}

			> div {
				padding: 5px;
				text-align: center;
				color: #FFF;
				position: absolute;
				width: 100%;
				height: 25%;
				bottom: 0;
				left: 0;
				right: 0;
				background: rgba(0,0,0,0.3);
				z-index: 1;
				&:hover {
					cursor: pointer;
				}
			}
		}
	}
}
@media screen and (min-width: 960px) {
	.border-right-md {
		border-right: 3px solid #f0f0f0;
	}
	.profile-header {
		text-align: center;
		width: 100%;
		padding: 2px;
		text-align: center;

		&__user-image {
			margin: 0 auto;
			overflow: hidden;
			object-fit: cover;
			border: 5px solid #fafafa;
			border-radius: 50%;
			max-width: 180px;
			max-height: 180px;

			> img {
				width: 100%;
			}

			> div {
				padding: 5px;
				text-align: center;
				color: #FFF;
				position: absolute;
				width: 100%;
				height: 25%;
				bottom: 0;
				left: 0;
				right: 0;
				background: rgba(0,0,0,0.3);
				z-index: 1;
				&:hover {
					cursor: pointer;
				}
			}
		}
	}
}
</style>
